import React, { useState, useEffect, useRef } from 'react';
import './Chatbot.css';

const predefinedQuestions = [
  {
    question: "📍 Where is the college?",
    answer: "Our college is located at Nighoj, Tal. Parner, Dist. Ahmednagar, Maharashtra, India."
  },
  {
    question: "📅 What are the office hours?",
    answer: "Office hours are Monday to Saturday, 10:00 AM to 5:00 PM."
  },
  {
    question: "🎓 Courses offered?",
    answer: "We offer B.Sc. Computer Science, B.A., B.Sc. and more."
  },
  {
    question: "📞 Contact number?",
    answer: "You can contact us at +91-9876543210."
  }
];

const Chatbot = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const chatEndRef = useRef(null);
  const [showPopup, setShowPopup] = useState(true);

  // Scroll to latest message
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // Load initial message
  useEffect(() => {
    const saved = localStorage.getItem('chat_messages');
    if (saved) {
      setMessages(JSON.parse(saved));
    } else {
      const welcome = [{ sender: 'bot', text: 'Hi! 👋 I’m your assistant. How can I help you today?' }];
      setMessages(welcome);
      localStorage.setItem('chat_messages', JSON.stringify(welcome));
    }

    // Auto-hide popup message after 5 seconds
    const timer = setTimeout(() => setShowPopup(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  // Save chat to localStorage
  useEffect(() => {
    localStorage.setItem('chat_messages', JSON.stringify(messages));
  }, [messages]);

  const typeWriterEffect = (text, callback) => {
    let i = 0;
    let currentText = '';
    setTyping(true);

    const interval = setInterval(() => {
      currentText += text.charAt(i);
      setMessages(prev => [
        ...prev.slice(0, -1),
        { sender: 'bot', text: currentText }
      ]);
      i++;
      if (i >= text.length) {
        clearInterval(interval);
        setTyping(false);
        callback && callback();
      }
    }, 30);
  };

  const handleSend = (userText = '') => {
    const question = userText || input.trim();
    if (!question) return;

    setMessages(prev => [...prev, { sender: 'user', text: question }, { sender: 'bot', text: '' }]);

    const matched = predefinedQuestions.find(q =>
      q.question.toLowerCase().includes(question.toLowerCase().slice(0, 6))
    );
    const reply = matched ? matched.answer : "Thanks for asking! We'll reply to your message soon.";

    setTimeout(() => {
      typeWriterEffect(reply);
    }, 500);

    setInput('');
  };

  const handleClear = () => {
    const freshStart = [{ sender: 'bot', text: 'Hi again! 👋 How can I help you today?' }];
    setMessages(freshStart);
    localStorage.setItem('chat_messages', JSON.stringify(freshStart));
  };

  return (
    <div className="chatbot-container">
      {!open && (
        <div
          className="chatbot-hover-wrapper"
          onMouseEnter={() => setShowPopup(true)}
          onMouseLeave={() => setShowPopup(false)}
        >
          {showPopup && <div className="chatbot-popup-message">How can I help you?</div>}
          <button className="chatbot-toggle" onClick={() => setOpen(true)}>💬</button>
        </div>
      )}

      {open && (
        <div className="chatbot-box slide-in">
          <div className="chatbot-header">
            <span>Chat with Us</span>
            <div className="chatbot-header-buttons">
              <button onClick={handleClear}>🗑</button>
              <button onClick={() => setOpen(false)}>✖</button>
            </div>
          </div>

          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`chatbot-message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
            <div ref={chatEndRef} />
          </div>

          {!typing && (
            <div className="chatbot-quick-buttons">
              {predefinedQuestions.map((q, i) => (
                <button key={i} onClick={() => handleSend(q.question)}>
                  {q.question}
                </button>
              ))}
            </div>
          )}

          <div className="chatbot-input">
            <input
              type="text"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSend()}
              placeholder="Type your message..."
              disabled={typing}
            />
            <button onClick={() => handleSend()} disabled={typing}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
